/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Modal, Group, Box, Center } from '@mantine/core';

// Components
import { Button, Text, Title } from '@components/v2/ui';

// Styles
import classes from './DefaultModal.module.css';

// I18n
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const DefaultModal = (props: {
	onConfirm: () => void;
	onClose: () => void;
	title: string;
	description?: string;
	opened: boolean;
	type?: 'information' | 'OKOnly' | 'question';
}) => {
	/* ******************************** HOOKS *********************************** */
	const { t } = useTranslation();

	/* ******************************** RENDERING ******************************* */

	if (props.type == 'information') {
		return (
			<Modal
				opened={props.opened}
				onClose={props.onClose}
				classNames={classes}
				withCloseButton={false}
				size={500}
			>
				<Center>
					<Title order={5}>{props.title}</Title>
				</Center>
				<Box className={classes.spacer} />
				<Text
					variant="body2"
					className={classes.description}
				>
					{props.description}
				</Text>
				<Group mt="xl" justify="center">
					<Button
						variant="primary"
						onClick={props.onClose}
					>
						{t('global.return')}
					</Button>
				</Group>
			</Modal>
		);
	}

	return (
		<Modal
			opened={props.opened}
			onClose={props.onClose}
			classNames={classes}
			withCloseButton={false}
			size={500}
		>
			<Center>
				<Title order={5}>{props.title}</Title>
			</Center>
			<Box className={classes.spacer} />
			<Text variant="body2">{props.description}</Text>
			<Group mt="xl" justify="center">
				<Button
					color="inputs-texts-icons"
					variant="transparent"
					onClick={props.onClose}
				>
					{t('global.cancel')}
				</Button>
				<Button
					variant="primary"
					onClick={props.onConfirm}
				>
					{t('global.iConfirm')}
				</Button>
			</Group>
		</Modal>
	);
};
